import { styled } from "styled-components";
export const BlurScreen = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 10px 14px;
    gap: 10px;
    backdrop-filter: blur(0px);
    opacity: 0.1;
    animation: showDelay 300ms forwards, showBlur 200ms forwards;
    @keyframes showDelay {
      from {
        opacity: 0.1;
        }
      to {
        opacity: 1;
      }
    }
    @keyframes showBlur {
      from {
        backdrop-filter: blur(0px);
      }
      to {
        backdrop-filter: blur(10px);
      }
    }
`;

export default BlurScreen;
